import React from 'react'
import {useOnEvent} from 'react-app-events'
import DeliveryWizard from '@components/DeliveryWizard'
import SafeSuspense from '@components/SafeSuspense'
import SuspenseLoading from '@components/SuspenseLoading/Loading'
import {useMyOrderPreferencesSlim} from '@data/queries/preferences/getMyOrderPreferencesSlim.main'
import useMessage from '@hooks/useMessage'
import useRef from '@hooks/useRef'
import useState from '@hooks/useState'
import {useTranslation} from 'next-i18next'

import OptionsTableServe from './OptionsTableServe'

export default function Options() {
  const container = useRef()
  const [hiddenPrice, setHiddenPrice] = useState(false)
  const {data} = useMyOrderPreferencesSlim()
  const {preferences} = data ?? {}
  const showMessage = useMessage()
  const {t} = useTranslation('website', {keyPrefix: 'delivery'})

  useOnEvent('hiddenPriceProductOpened', async () => {
    showMessage(t('hiddenPriceWarning'))
    setHiddenPrice(true)
  })

  const hide = preferences.deliveryType === 'serve' && preferences.tableName !== null

  if (hide) {
    return <OptionsTableServe />
  }

  return (
    <div ref={container}>
      {hiddenPrice ? (
        <DeliveryWizard.AsModal
          actionLocation="order-options"
          isOpen
          onClose={() => setHiddenPrice(false)}
        />
      ) : null}
      <SafeSuspense fallback={<SuspenseLoading />}>
        <DeliveryWizard.AsComponent />
      </SafeSuspense>
    </div>
  )
}
